import { useCallback, useState } from "react";
import type { RecipientBookEntry } from "../api/recipients";
import { sendMockRecipients } from "../gallery/sendMock";

export interface UseRecipientsState {
  recipients: RecipientBookEntry[];
  loading: boolean;
  refresh: () => void;
}

/**
 * Gallery-safe recipient book. Returns static mock entries (no network).
 */
export const useRecipients = (limit = 10): UseRecipientsState => {
  const slice = useCallback(
    () => sendMockRecipients.slice(0, Math.max(limit, 0)),
    [limit]
  );
  const [recipients, setRecipients] = useState<RecipientBookEntry[]>(() =>
    slice()
  );
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(() => {
    setLoading(true);
    window.setTimeout(() => {
      setRecipients(slice());
      setLoading(false);
    }, 180);
  }, [slice]);

  return { recipients, loading, refresh };
};
